import cx from 'classnames';

import { IconChevronDown } from '../icons/ChevronDown';
import { IconChevronLeft } from '../icons/ChevronLeft';
import { IconChevronRight } from '../icons/ChevronRight';
import { IconChevronUp } from '../icons/ChevronUp';

import { Anchor, AnchorProps } from './Anchor';
import style from './AnchorWithArrow.module.css';

type Props = AnchorProps & {
    position?: 'right' | 'left';
    direction?: 'right' | 'left' | 'up' | 'down';
    arrowClassName?: string;
};

export function AnchorWithArrow({
    position = 'right',
    direction = 'right',
    arrowClassName: arrowClassNameProp,
    ...props
}: Props) {
    const arrowClassName = position === 'right' ? style.positionRight : style.positionLeft;

    let arrow = null;
    switch (direction) {
        case 'right':
            arrow = <IconChevronRight className={cx(arrowClassName, arrowClassNameProp)} />;
            break;
        case 'left':
            arrow = <IconChevronLeft className={cx(arrowClassName, arrowClassNameProp)} />;
            break;
        case 'up':
            arrow = <IconChevronUp className={cx(arrowClassName, arrowClassNameProp)} />;
            break;
        case 'down':
            arrow = <IconChevronDown className={cx(arrowClassName, arrowClassNameProp)} />;
            break;
    }

    return (
        <Anchor {...props} className={cx(style.wrapper, props.className)}>
            {position === 'left' ? arrow : null}
            {props.children}
            {position === 'right' ? arrow : null}
        </Anchor>
    );
}
